import React, { Fragment, useContext, useEffect, useState } from "react";
import Scaler from "../dash/components/scaler/Scaler";
import DashPage from "../dash/DashPage";
import styles from "./styles";

import { PagedDataView } from "../../components/lists/PagedDataView/PagedDataView";
import { api, Category, CategoryType, ICategoryList, IReportList, Report } from "../../logic/api";
import ReportListItem from "../../components/lists/listItems/ReportListItem/ReportListItem";
import usePaths from "../../utility/paths";
import { useHistory, useParams } from "react-router-dom";
import ReportCreateNew from "./components/ReportCreateNew";
import { SessionContext } from "../../utility/useSession";
import { TextField, InputAdornment, IconButton, Button } from "@mui/material";
import flex from "../../styles/flex";
import SearchIcon from "@mui/icons-material/Search";
import { FiChevronLeft } from "react-icons/fi";
import CategoryListItem from "../../components/lists/listItems/CategoryItem/CategoryItem";
import ReportEdit from "./components/ReportEdit";
import NotFoundPage from "../error/NotFoundPage";
import { isSysAdmin } from "../../utility/utils";
import { useTranslation } from "react-i18next";
import { ReleaseFlag, useReleaseManagement } from "../../utility/feature-management";

interface IReportByCategoryParams {
    category: string;
}

const ReportsPage = () => {
    const paths = usePaths();
    const session = useContext(SessionContext);
    const history = useHistory();
    const deleteReportApi = api.hooks.reports.delete();
    const { t } = useTranslation();

    if (session.current.site == null) {
        return <Fragment></Fragment>;
    }

    if (session.current.site.preferences.reports_v1 == false && isSysAdmin(session) == false) {
        return <NotFoundPage title={t("notFoundPage.notAvailable")} message={t("notFoundPage.featureNotEnabled")} />
    }




    const [filter, setFilter] = useState("");

    let defaultReportCategory = "";

    if (session.current.site != null) {
        if (session.current.site.preferences.default_report_category != null) {
            defaultReportCategory = session.current.site.preferences.default_report_category;
        }
    }

    const params: IReportByCategoryParams = useParams();

    if (params.category != null && params.category != "") {
        defaultReportCategory = decodeURIComponent(params.category);
    }

    const isExcludeCentralReportsReleased = useReleaseManagement(ReleaseFlag.releaseReports9056);

    const [reportParams, setReportParams] = useState<IReportList>({
        category: defaultReportCategory,
        excludeCentral: isExcludeCentralReportsReleased,
    });
    const [categoryName, setCategoryName] = useState(defaultReportCategory);

    const [categoryParams] = useState<ICategoryList>({
        type: CategoryType.reports
    });

    const [editReport, setEditReport] = useState<Report | null>(null);
    const [showEditReport, setShowEditReport] = useState(false);

    const carParkId = !session.current.site?.home?.id || null;
    const [currentCarParkId, setCurrentCarParkId] = useState(carParkId);

    useEffect(() => {
        if (carParkId != currentCarParkId) {
            setReportParams({ ...reportParams });
            setCurrentCarParkId(carParkId);

        }
    }, [carParkId]);

    return (
        <DashPage>
            {editReport != null && (
                <ReportEdit report={editReport} show={showEditReport} onClose={(didUpdate) => {
                    setShowEditReport(false);
                    if (didUpdate == true) {
                        setReportParams({ ...reportParams });
                    }
                }}></ReportEdit>
            )}
            <div style={styles.wrapper}>
                <div style={styles.container}>
                    <div style={{ textAlign: "left" }}>
                        <Scaler><div><h1 style={styles.title}>{t("reports.title")}</h1></div></Scaler>
                    </div>
                    <div style={{ textAlign: "left" }}>


                        <div style={{ padding: 10, textAlign: "right" }}>
                            <div style={flex.flexRows}>

                                <div style={flex.flexAuto}>
                                    {(categoryName.length > 0 || (reportParams != null && reportParams.filter || "").length > 0) && (
                                        <Button
                                            variant="outlined"
                                            onClick={() => {
                                                history.push(paths.reports);
                                                setCategoryName("");
                                                setFilter("");
                                                setReportParams({ ...reportParams, filter: "", category: "" });
                                            }}><FiChevronLeft style={{ marginRight: 10 }}></FiChevronLeft>{t("reports.categories")}</Button>
                                    )}
                                </div>
                                <div style={flex.flexFill}>

                                </div>
                                <div style={flex.flexAuto}>
                                    <TextField
                                        autoFocus={false}
                                        label={t("reports.searchCategory", { name: categoryName }) || t("reports.title")}
                                        variant="outlined"
                                        size="small"
                                        type="search"
                                        value={filter}
                                        onChange={(e) => {
                                            setFilter(e.currentTarget.value);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                if (e.currentTarget) {
                                                    e.currentTarget.blur();
                                                    setReportParams({ ...reportParams, filter: filter, category: categoryName });
                                                }
                                                return false;
                                            }

                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position={"end"}>
                                                    <IconButton
                                                        style={{ padding: 0 }}
                                                        onClick={() => {
                                                            setReportParams({ ...reportParams, filter: filter, category: categoryName });
                                                        }}>
                                                        <SearchIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                                <div style={flex.flexAuto}>
                                    <div style={{ marginLeft: 10 }}><ReportCreateNew category={categoryName}></ReportCreateNew></div>

                                </div>
                            </div>
                        </div>

                        {(categoryName.length == 0 && (reportParams == null || (reportParams.filter || "").length == 0)) && (
                            <PagedDataView<ICategoryList, Category>
                                apiHook={api.hooks.category.list}
                                parameters={categoryParams}
                                renderItem={(item) => {
                                    return <CategoryListItem item={item} onClick={() => {
                                        history.push(paths.reportsWithCategory(encodeURIComponent(item.categoryName)));
                                        setCategoryName(item.categoryName);
                                        setReportParams({ ...reportParams, filter: filter, category: item.categoryName });
                                    }}></CategoryListItem>
                                }}
                            ></PagedDataView>
                        )}


                        {reportParams != null && (((reportParams.filter || "").length > 0 || categoryName.length > 0)) && (
                            <PagedDataView<IReportList, Report>
                                apiHook={api.hooks.reports.list}
                                parameters={reportParams}
                                renderItem={(item) => {
                                    return <ReportListItem item={item}
                                        onClick={() => {
                                            history.push(paths.reportView(item.id.toString()));
                                        }}
                                        onDelete={() => {
                                            deleteReportApi.send(session.current.context, {
                                                reportId: item.id
                                            });
                                        }}
                                        onEdit={() => {
                                            setEditReport(item);
                                            setShowEditReport(true);

                                        }}
                                        onDesign={() => {
                                            history.push(paths.reportEdit(item.id.toString()));
                                        }}
                                    />
                                }}
                            ></PagedDataView>
                        )}


                    </div>
                </div>
            </div>
        </DashPage >
    );
}

export default ReportsPage;
